import styled from 'styled-components';

export const AnimationFillStyles = styled.div<{
  titleToItemsSpacing?: number;
  itemsSpacing?: number;
}>`
  display: flex;
  flex-direction: column;
  padding: 0 16px;
  gap: ${({ itemsSpacing = 24 }) => itemsSpacing}px;
  margin: 0 0 32px;

  .process {
    &-data {
      margin: 0 0 ${({ titleToItemsSpacing = 8 }) => titleToItemsSpacing}px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }

    &-progress {
      width: 100%;
      height: 8px;
      background: #765279;
      border-radius: 8px;
      position: relative;

      &-bar {
        position: absolute;
        top: 0;
        left: 0;
        width: 0%;
        height: 100%;
        background: linear-gradient(126deg, #7f36f3 21.37%, #ed0d80 105.25%);
        border-radius: 8px;
      }
    }
  }
`;
